import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { Util } from 'src/shared/util/util';
import { WindowService } from 'src/shared/providers/window.service';
import { GuestReservations } from 'src/providers/guest-reservations/guest-reservations';
import { AddIntegrationPage } from 'src/pages/integrations/add-integration/add-integration';

import { TranslationPipe } from 'src/shared/pipes/translation.pipe';

@Component({
    templateUrl: 'integrate.html',
    styleUrls: ['./integrate.scss'],
    standalone: false
})
export class IntegratePage implements OnInit, OnDestroy {
  upsellPartners: any[] = [];
  loading = false;
  errorMessage: string;
  dialogParams: any;
  isRightSideContent = true;
  loaded: boolean;

  
  boundClose = this.close.bind(this);

constructor(
    private storage: TidyStorage,
    private navCtrl: CustomNavController,
    private rightSidePanelService: RightSidePanelService,
    private util: Util,
    private windowService: WindowService,
    private guestReservations: GuestReservations,
    private cdr: ChangeDetectorRef
  ) {}

  async ngOnInit() {
    try {
      this.isRightSideContent =
        (await this.storage.retrieve('dialog-right-side-open')) || false;
      this.dialogParams = await this.storage.retrieve('dialog-params');

      this.rightSidePanelService.setDialogPageTitle(new TranslationPipe().transform('Upsell Integration'));
      this.loadData();
    } catch (err) {
      this.errorMessage = err.error ? err.error.message : err.message;
    }
  }

  async loadData() {
    try {
      await this.loadUpsellPartners();
      this.loaded = true;
    } catch (err) {
      this.errorMessage = err.error ? err.error.message : err.message;
    }
  }

  async loadUpsellPartners() {
    this.loading = true;
    try {
      const allIntegrations = await this.guestReservations.getSourceTypes(true);

      this.upsellPartners = allIntegrations.filter((integration: any) =>
        integration.active_details?.some((detail: any) =>
          detail.key === 'category' && detail.value === 'Upsells'
        )
      );

      // Force change detection
      this.cdr.detectChanges();
    } catch (_error) {
      this.util.showError(new TranslationPipe().transform('Unable to load integration partners'), 3000);
    } finally {
      this.loading = false;
      this.cdr.detectChanges();
    }
  }

  trackByPartnerId(_index: number, partner: any): any {
    return partner.id;
  }

  async openPartnerIntegration(partner: any) {
    // Prepare integration data similar to how it's done in integrations page
    const params = {
      integration: partner,
      reservationSrcType: partner  // Pass the partner object instead of just 'upsell' string
    };

    if (this.windowService.isDesktopRes) {
      // Desktop: Use right-side panel
      this.storage.save('dialog-right-side-open', true);
      this.storage.save('dialog-params', params);
      this.rightSidePanelService.navigateTo('add-integration', params, AddIntegrationPage);
    } else {
      // Mobile: Full page navigation
      this.navCtrl.navigateForward('/add-integration', params);
    }
  }

  close() {
    if (this.isRightSideContent) {
      this.rightSidePanelService.closeRightSidePanel();
    } else {
      this.navCtrl.navigateRoot('upsells');
    }
  }

  ngOnDestroy() {
    // Clean up any necessary data when component is destroyed
  }
}
